import i18n from '../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';
import React from 'react';
import PropTypes from 'prop-types';

const dash = ' - ';
const LinkToDocumentPlaceholder = ({startDocumentSelection}) => {
  const textPlaceholderLinkToDocument = i18n.t('new.placeholder.linkToDocument');
  const textLinkToDocumentAction = i18n.t('new.placeholder.linkToDocumentAction');
  return (
    <div className="LinkToDocumentField__placeholder">
      {textPlaceholderLinkToDocument}
      {dash}
      <Button styleType={Button.StyleType.INLINE_LINK} onClick={startDocumentSelection}>
        {textLinkToDocumentAction}
      </Button>
    </div>
  );
};

LinkToDocumentPlaceholder.displayName = 'LinkToDocumentPlaceholder';

LinkToDocumentPlaceholder.propTypes = {
  startDocumentSelection: PropTypes.func.isRequired
};

export default LinkToDocumentPlaceholder;
